import { BadgeType } from "components/atoms/Badge/Badge";

const QuickRequestStatusColors: Record<string, BadgeType> = {
  Shipping: "primary",
  Processing: "warning",
  Pending: "danger",
  Draft: "secondary",
  Archived: "secondary",
  Canceled: "secondary",
};

export default QuickRequestStatusColors;
